// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var ContentOptionality$SmartcutsMacros = require("../../semantics/ContentOptionality.bs.js");
var SelectionWithSemantics$SmartcutsMacros = require("./SelectionWithSemantics.bs.js");
var ContentOptionalityConfig$SmartcutsMacros = require("../../semantics/ContentOptionalityConfig.bs.js");
var Selection__StrictSelection$SmartcutsMacros = require("../../Selection/Selection__StrictSelection.bs.js");
var SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros = require("../../SelectionSemantics/SelectionSemantics__StrictSelectionSemantics.bs.js");

function t_encode(v) {
  return Selection__StrictSelection$SmartcutsMacros.ForRecording.t_encode(v);
}

function t_decode(v) {
  return Selection__StrictSelection$SmartcutsMacros.ForRecording.t_decode(v);
}

var stringify = Selection__StrictSelection$SmartcutsMacros.ForRecording.stringify;

var Recording = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

var t_encode$1 = SelectionWithSemantics$SmartcutsMacros.t_encode;

var t_decode$1 = SelectionWithSemantics$SmartcutsMacros.t_decode;

function fromRecordingCommandValue(selection) {
  var semantics = SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.ofSelection(selection);
  return {
          selection: Selection__StrictSelection$SmartcutsMacros.ForNonRecording.fromRecording(selection),
          semantics: semantics
        };
}

var updateSelector = SelectionWithSemantics$SmartcutsMacros.updateSelector;

var Authoring = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: SelectionWithSemantics$SmartcutsMacros.stringify,
  fromRecordingCommandValue: fromRecordingCommandValue,
  updateSelector: updateSelector
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "optionality",
                ContentOptionality$SmartcutsMacros.t_encode(v.optionality)
              ],
              [
                "semantic",
                SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v.semantic)
              ],
              [
                "originalSelection",
                Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_encode(v.originalSelection)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var optionality = ContentOptionality$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "optionality"), null));
  if (optionality.TAG === /* Ok */0) {
    var semantic = SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantic"), null));
    if (semantic.TAG === /* Ok */0) {
      var originalSelection = Selection__StrictSelection$SmartcutsMacros.ForNonRecording.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalSelection"), null));
      if (originalSelection.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  optionality: optionality._0,
                  semantic: semantic._0,
                  originalSelection: originalSelection._0
                }
              };
      }
      var e = originalSelection._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".originalSelection" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = semantic._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".semantic" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = optionality._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".optionality" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function selectorGet(param) {
  return SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.selectorGet(param.semantic);
}

function stringify$1(param) {
  return "{ semantic: " + (SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.Semantic.stringify(param.semantic) + (", originalSelection, optionality: " + (ContentOptionality$SmartcutsMacros.stringify(param.optionality) + "}")));
}

var Playback = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  selectorGet: selectorGet,
  stringify: stringify$1
};

var CommandValue = {
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function fromAuthoringCommandValue(param) {
  var semantics = param.semantics;
  return {
          selection: param.selection,
          semantics: semantics,
          config: SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.getFirstSemantic(semantics)
        };
}

function applyToAuthoringCommandValueToGetPlaybackSemantic(commandValue, maybeConfig) {
  if (maybeConfig !== undefined) {
    return maybeConfig.config;
  } else {
    return SelectionSemantics__StrictSelectionSemantics$SmartcutsMacros.getFirstSemantic(commandValue.semantics);
  }
}

function isForAuthoringCommandValue(param, config) {
  return Caml_obj.caml_equal(config.selection, param.selection);
}

var SelectedContentConfig = {
  fromAuthoringCommandValue: fromAuthoringCommandValue,
  applyToAuthoringCommandValueToGetPlaybackSemantic: applyToAuthoringCommandValueToGetPlaybackSemantic,
  isForAuthoringCommandValue: isForAuthoringCommandValue
};

function isDynamic(param) {
  return false;
}

function fromAuthoringCommandValue$1(authoringCommandValue) {
  return {
          selectedContentConfig: fromAuthoringCommandValue(authoringCommandValue),
          contentOptionalityConfig: ContentOptionalityConfig$SmartcutsMacros.$$default
        };
}

function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, maybeConfig) {
  var arg = OptionUtils$SmartcutsMacros.map(maybeConfig, (function (config) {
          return config.contentOptionalityConfig;
        }));
  return {
          optionality: (function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })(ContentOptionalityConfig$SmartcutsMacros.$$default),
          semantic: applyToAuthoringCommandValueToGetPlaybackSemantic(commandValue, OptionUtils$SmartcutsMacros.map(maybeConfig, (function (config) {
                      return config.selectedContentConfig;
                    }))),
          originalSelection: commandValue.selection
        };
}

function isForAuthoringCommandValue$1(commandValue, config) {
  return isForAuthoringCommandValue(commandValue, config.selectedContentConfig);
}

var AuthoringConfig = {
  SelectedContentConfig: SelectedContentConfig,
  isDynamic: isDynamic,
  fromAuthoringCommandValue: fromAuthoringCommandValue$1,
  applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue,
  isForAuthoringCommandValue: isForAuthoringCommandValue$1
};

exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
/* SelectionWithSemantics-SmartcutsMacros Not a pure module */
